import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';

const GuidelineModal = ({showGuidelines, setShowGuidelines}) => {
  if (!showGuidelines) return null;
  return (
    <Modal
      type={MODAL_TYPE.FLUID}
      showModal={showGuidelines}
      onCloseModal={() => setShowGuidelines(false)}
      title='Guidelines'
      text='Wheel of Fortune Display'
      isDark
      showPrimaryButton={false}
      showSecondaryButton={false}
      onClickPrimaryButton={() => setShowGuidelines(false)}
      onClickSecondaryButton={() => {}}
      primaryButtonText=''
      secondaryButtonText=''
      className='guideline-modal'
      content={
        <div
          className='flex flex-col gap-[20px] overflow-y-auto rounded-lg p-[24px_16px]'
          style={{
            background: '#262626',
            maxHeight: '511px'
          }}>
          <div className='flex items-center justify-between'>
            <p
              className='font-bold text-white'
              style={{fontSize: '16px', lineHeight: '22px'}}>
              PepsiConnect {'->'} Club+ {'->'} Games
            </p>
          </div>
          <div className='text-sm text-[#DADADA]'>
            <p>Guideline placeholder text for Wheel of Fortune display.</p>
            <p className='mt-2'>
              Asset paths and detailed guidelines to be filled in later.
            </p>
          </div>
        </div>
      }
    />
  );
};

GuidelineModal.propTypes = {
  showGuidelines: PropTypes.bool.isRequired,
  setShowGuidelines: PropTypes.func.isRequired
};

export default React.memo(GuidelineModal);
